import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";
import { toast } from "react-toastify";

const ManpowerOvertime = () => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);

    const [filters, setFilters] = useState({
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
    });

    const months = [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
        { value: 7, label: "July" },
        { value: 8, label: "August" },
        { value: 9, label: "September" },
        { value: 10, label: "October" },
        { value: 11, label: "November" },
        { value: 12, label: "December" },
    ];

    const years = Array.from(
        { length: 5 },
        (_, i) => new Date().getFullYear() - 2 + i
    );

    const formatNumber = (value) =>
        Number(value || 0).toLocaleString("en-IN", {
            maximumFractionDigits: 2,
        });

    const getMonthName = () =>
        months.find(
            (m) => Number(m.value) === Number(filters.month)
        )?.label || "";

    const fetchData = async () => {
        try {
            setLoading(true);

            const token = getAuthToken();

            const response = await axios.post(
                `${config.API}/senmanager/manpowerovertime`,
                {
                    month: Number(filters.month),
                    year: Number(filters.year),
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data?.success) {
                setRows(response.data.data || []);
            } else {
                setRows([]);
                toast.warning(
                    response.data?.message ||
                    "No manpower data found."
                );
            }
        } catch (error) {
            console.error(error);
            setRows([]);
            toast.error(
                error.response?.data?.message ||
                "Unable to load manpower data."
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div
            className="container-fluid py-3"
            style={{ background: "#f5f7fa" }}
        >
            <div className="card border shadow-sm">

                {/* HEADER */}

                <div className="card-header bg-white py-3 px-3">
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">

                        <h5
                            className="mb-0 fw-bold"
                            style={{ color: "#17365d" }}
                        >
                            Manpower and Overtime -{" "}
                            {getMonthName()} {filters.year}
                        </h5>

                        <button
                            type="button"
                            className="btn btn-sm btn-light border fw-semibold"
                        >
                            Create PDF
                        </button>

                    </div>
                </div>

                {/* INFORMATION */}

                <div
                    className="px-3 py-2"
                    style={{
                        background: "#fff9e6",
                        borderBottom: "1px solid #ead9a4",
                        color: "#9a4215",
                        fontSize: "12px",
                    }}
                >
                    The operating-shift column states the duration used
                    for each row. For a 24-hour IM schedule, two separate
                    12-hour shifts operate each day and the workmen figure
                    is the crew required for each 12-hour shift.
                </div>

                {/* FILTER */}

                <div className="card-body bg-white py-3 px-3 border-bottom">

                    <div className="d-flex flex-wrap justify-content-end align-items-center gap-2">

                        <strong
                            style={{ color: "#17365d" }}
                        >
                            Month / Year
                        </strong>

                        <select
                            className="form-select form-select-sm"
                            style={{ width: "145px" }}
                            value={filters.month}
                            onChange={(e) =>
                                setFilters({
                                    ...filters,
                                    month: e.target.value,
                                })
                            }
                        >
                            {months.map((month) => (
                                <option
                                    key={month.value}
                                    value={month.value}
                                >
                                    {month.label}
                                </option>
                            ))}
                        </select>

                        <select
                            className="form-select form-select-sm"
                            style={{ width: "100px" }}
                            value={filters.year}
                            onChange={(e) =>
                                setFilters({
                                    ...filters,
                                    year: e.target.value,
                                })
                            }
                        >
                            {years.map((year) => (
                                <option
                                    key={year}
                                    value={year}
                                >
                                    {year}
                                </option>
                            ))}
                        </select>

                        <button
                            type="button"
                            className="btn btn-sm btn-primary px-3 fw-semibold"
                            onClick={fetchData}
                        >
                            Search
                        </button>

                    </div>
                </div>

                {/* TABLE */}

                <div className="table-responsive">
                    <table
                        className="table table-hover align-middle mb-0"
                        style={{
                            minWidth: "1050px",
                            fontSize: "13px",
                        }}
                    >
                        <thead>
                            <tr
                                style={{
                                    background: "#f1f5f9",
                                    borderBottom: "2px solid #d9e1ea",
                                }}
                            >
                                <th
                                    className="px-3 py-3"
                                    style={{
                                        color: "#17365d",
                                        fontWeight: 700,
                                        width: "60px",
                                    }}
                                >
                                    S.No.
                                </th>

                                <th
                                    className="py-3"
                                    style={{
                                        color: "#17365d",
                                        fontWeight: 700,
                                        minWidth: "230px",
                                    }}
                                >
                                    Workstation
                                </th>

                                <th
                                    className="py-3"
                                    style={{
                                        color: "#17365d",
                                        fontWeight: 700,
                                        minWidth: "280px",
                                    }}
                                >
                                    Applicability / Basis
                                </th>

                                <th
                                    className="py-3"
                                    style={{
                                        color: "#17365d",
                                        fontWeight: 700,
                                        minWidth: "160px",
                                    }}
                                >
                                    Latest Operator
                                </th>

                                <th
                                    className="py-3 text-center"
                                    style={{
                                        color: "#17365d",
                                        fontWeight: 700,
                                        minWidth: "130px",
                                    }}
                                >
                                    Workmen Required / That Shift
                                </th>

                                <th
                                    className="py-3 text-center"
                                    style={{
                                        color: "#17365d",
                                        fontWeight: 700,
                                        minWidth: "110px",
                                    }}
                                >
                                    Operating Shift
                                </th>
                                <th
                                    className="py-3 text-center"
                                    style={{
                                        color: "#17365d",
                                        fontWeight: 700,
                                        minWidth: "110px",
                                    }}
                                >
                                    Total Man-hours
                                </th>
                                <th
                                    className="py-3 text-center"
                                    style={{
                                        color: "#17365d",
                                        fontWeight: 700,
                                        minWidth: "110px",
                                    }}
                                >
                                    Overtime Man-hours
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading ? (
                                <tr>
                                    <td
                                        colSpan="6"
                                        className="text-center py-5"
                                    >
                                        <div
                                            className="spinner-border text-primary"
                                            role="status"
                                        />

                                        <div className="text-muted mt-2">
                                            Loading manpower data...
                                        </div>
                                    </td>
                                </tr>
                            ) : rows.length > 0 ? (
                                rows.map((item, index) => (
                                    <tr
                                        key={
                                            item?.machine_id ||
                                            `machine-${index}`
                                        }
                                        style={{
                                            borderBottom:
                                                "1px solid #edf0f3",
                                        }}
                                    >
                                        {/* S.NO */}

                                        <td className="px-3 text-muted fw-semibold">
                                            {index + 1}
                                        </td>

                                        {/* MACHINE */}

                                        <td>
                                            <div className="fw-bold text-dark">
                                                {item?.machine?.name ||
                                                    "-"}
                                            </div>

                                            <small className="text-muted">
                                                Machine ID:{" "}
                                                {item?.machine_id || "-"}
                                            </small>
                                        </td>

                                        {/* PRODUCT */}

                                        <td>
                                            <div className="fw-semibold text-dark">
                                                {item?.product?.name ||
                                                    "-"}
                                            </div>

                                            {item?.product?.id && (
                                                <small className="text-muted">
                                                    Product ID:{" "}
                                                    {item.product.id}
                                                </small>
                                            )}
                                        </td>

                                        {/* OPERATOR */}

                                        <td>
                                            <div className="fw-semibold text-dark">
                                                {item?.operator?.name ||
                                                    "-"}
                                            </div>

                                            {item?.operator_id && (
                                                <small className="text-muted">
                                                    Operator ID:{" "}
                                                    {item.operator_id}
                                                </small>
                                            )}
                                        </td>

                                        {/* OPERATOR COUNT */}

                                        <td className="text-center">
                                            <span
                                                className="badge rounded-pill"
                                                style={{
                                                    background:
                                                        "#e8f1ff",
                                                    color: "#2563eb",
                                                    padding:
                                                        "7px 14px",
                                                    fontSize: "13px",
                                                    fontWeight: 700,
                                                }}
                                            >
                                                {formatNumber(
                                                    item?.operator_count
                                                )}
                                            </span>
                                        </td>

                                        {/* SHIFT */}

                                        <td className="text-center">
                                            <span
                                                className="badge rounded-pill"
                                                style={{
                                                    background:
                                                        item?.shift ===
                                                            "Night"
                                                            ? "#e9e7ff"
                                                            : "#fff3cd",
                                                    color:
                                                        item?.shift ===
                                                            "Night"
                                                            ? "#5145cd"
                                                            : "#946200",
                                                    padding:
                                                        "7px 14px",
                                                    fontSize: "12px",
                                                    fontWeight: 600,
                                                }}
                                            >
                                                {item?.shift ||
                                                    "Not Assigned"}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            NA
                                        </td>
                                        <td className="text-center">
                                            NA
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan="6"
                                        className="text-center text-muted py-5"
                                    >
                                        No manpower data found.
                                    </td>
                                </tr>
                            )}
                        </tbody>

                        {!loading && rows.length > 0 && (
                            <tfoot>
                                <tr
                                    style={{
                                        background: "#f8fafc",
                                        borderTop:
                                            "2px solid #d9e1ea",
                                    }}
                                >
                                    <td
                                        colSpan="1"
                                        className="px-3 py-3 fw-bold"
                                        style={{
                                            color: "#17365d",
                                        }}
                                    >
                                        Total Machines
                                    </td>

                                    <td className="text-center fw-bold">
                                        {rows.length}
                                    </td>

                                    <td></td>
                                </tr>
                            </tfoot>
                        )}
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ManpowerOvertime;